import { render, staticRenderFns } from "./goTop.vue?vue&type=template&id=da072f90&scoped=true"
import script from "./goTop.vue?vue&type=script&lang=js"
export * from "./goTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da072f90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da072f90')) {
      api.createRecord('da072f90', component.options)
    } else {
      api.reload('da072f90', component.options)
    }
    module.hot.accept("./goTop.vue?vue&type=template&id=da072f90&scoped=true", function () {
      api.rerender('da072f90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/goTop.vue"
export default component.exports